// SHY payment accounts. `value` must match the CRM/portal picklist value exactly.
const paymentAccountList = [
    { value: "Barclays GBP", label: "Barclays GBP" },
    { value: "Barclays EURO", label: "Barclays EURO" },
    { value: "Barclays USD", label: "Barclays USD" },
    { value: "HSBC New York USD", label: "HSBC New York USD" },
    { value: "Revolut GBP", label: "Revolut GBP" },
    { value: "Revolut EURO", label: "Revolut EURO" },
    { value: "Revolut USD", label: "Revolut USD" },
    { value: "Revolut AED", label: "Revolut AED" },
    { value: "Revolut USD USA Based", label: "Revolut USD (USA based)" },
];

export { paymentAccountList };
